export class SkuAttrValue {
  type: AttrType;
  name: string;
  usable: boolean;
  data: { id: number; } & { groupId: number } | { id: number; color: string; } & { groupId: number } | { id: number; fileName: string; largeImage: string; smallImage: string; } & { groupId: number };
  constructor(value: SkuAttrTextValue | SkuAttrColorValue | SkuAttrImageValue, groupId: number) {
    const { type, name, usable, ...data } = value;
    this.type = type;
    this.name = name;
    this.usable = usable;
    this.data = { ...data, groupId };
  }
  getDisplayType(): AttrType {
    return this.type;
  }
  getTypeFrame(): TypeFrame {
    if (this.getDisplayType() === AttrType.TEXT) {
      return TypeFrame[AttrType.TEXT];
    }
    return TypeFrame[this.getDisplayType()];
  }
  getName(): string {
    return this.name;
  }
  getData() {
    return this.data;
  }
  getUsable() {
    return this.usable;
  }
}

interface SkuAttrValueMap {
  [valId: string]: SkuAttrValue
}
/**
 * 一个属性组（如颜色），包括属性组id、属性组name(颜色)、属性组下的各个属性values(蓝色、红色等)
 *
 * @export
 * @class SkuAttrGroup
 * @implements {SkuAttrGroupInterface}
 */
export class SkuAttrGroup implements SkuAttrGroupInterface {
  name: string;
  id: number;
  values: (SkuAttrTextValue | SkuAttrColorValue | SkuAttrImageValue)[];
  _values: SkuAttrValue[];
  _valMap: SkuAttrValueMap;
  constructor(skuAttrId: number, skuAttrName: string, skuAttrValues: Array<SkuAttrTextValue | SkuAttrColorValue | SkuAttrImageValue>) {
    this.name = skuAttrName;
    this.id = skuAttrId;
    this.values = skuAttrValues;
    this._valMap = {};
    this._values = skuAttrValues ? skuAttrValues.map((val) => {
      const v = new SkuAttrValue(val, skuAttrId);
      this._valMap[val.id] = v;
      return v;
    }) : [];
  }

  getAttrName(): string {
    return this.name;
  }

  getAttrId(): number {
    return this.id;
  }

  getValues(): SkuAttrValue[] {
    return this._values;
  }

  getDisplayType(): AttrType {
    return this.getValues()[0].type;
  }

  getValueByValId(valId: string): SkuAttrValue {
    return this._valMap[valId];
  }
}

interface SkuAttrGroupMap {
  [groupId: string]: SkuAttrGroup
}
/**
 * 
 *
 * @class SkuAttrViews
 * 
 * 
 */
export class SkuAttrViews {
  skuAttrViews: SkuAttrGroup[];
  _skuAttrGroupMap: SkuAttrGroupMap;
  constructor(skuAttrViews: SkuAttrGroup[]) {
    this._skuAttrGroupMap = {};
    if (skuAttrViews) {
      this.skuAttrViews = skuAttrViews.map((skuAttr) => {
        const g = new SkuAttrGroup(skuAttr.id, skuAttr.name, skuAttr.values);
        this._skuAttrGroupMap[skuAttr.id] = g;
        return g;
      });
    } else {
      this.skuAttrViews = [];
    }
  }

  getSkuAttrGroups(): SkuAttrGroup[] {
    return this.skuAttrViews;
  }

  getSkuAttrByIndex(index = 0) {
    return this.skuAttrViews ? this.skuAttrViews[index] : null;
  }

  getGroupByGroupId(groupId: number): SkuAttrGroup {
    return this._skuAttrGroupMap[groupId];
  }
}

interface SkuAttrGroupInterface {
  id: number,
  name: string,
  values: (SkuAttrTextValue | SkuAttrColorValue | SkuAttrImageValue)[];
}

export enum AttrType {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  COLOR = 'COLOR'
}

enum TypeFrame {
  TEXT = 'text-frame',
  IMAGE = 'picture-frame',
  COLOR = 'picture-frame',
}

export interface SkuAttrTextValue {
  id: number,
  name: string
  type: AttrType.TEXT,
  usable: boolean,
}

export interface SkuAttrImageValue {
  id: number,
  name: string
  type: AttrType.IMAGE,
  fileName: string,
  largeImage: string,
  smallImage: string,
  usable: boolean,
}

export interface SkuAttrColorValue {
  id: number,
  name: string
  type: AttrType.COLOR,
  color: string,
  usable: boolean,
}

interface SkuAttr {
  [skuAttrName: string]: SkuAttrValue
}

interface SkuInfoMap {
  [skuAttrIdIndex: string]: SkuPriceAndId
}

interface SkuPriceAndId {
  id: number,
  price: string,
  promotionPrice: string,
}

class SkuPrice {
  constructor(price: string, promotionPrice: string) {

  }
}

interface GetSkuAttrFromSkuAttrIdIndex {
  (skuAttrIdIndex: string, skuAttrViews: SkuAttrViews): SkuAttrSingleGroup[]
}

// 生成一次应该存储下来，不应该再循环了
const getSkuAttrFromSkuAttrIdIndex: GetSkuAttrFromSkuAttrIdIndex = function (skuAttrIdIndex: string, skuAttrViews: SkuAttrViews) {
  const groupIds = skuAttrIdIndex.split(';');
  const res: SkuAttrSingleGroup[] = [];
  groupIds.forEach((groupId) => {
    const attrIdAndValId = groupId.split(':');
    const attrGroupId = attrIdAndValId[0];
    const attrValId = attrIdAndValId[1];
    const currentGroup = skuAttrViews.getGroupByGroupId(Number(attrGroupId));
    const currentVal = currentGroup.getValueByValId(attrValId);
    const cur: SkuAttrSingleGroup = {
      id: currentGroup.id,
      name: currentGroup.name,
      value: currentVal
    };
    res.push(cur);
  });
  return res;
}

interface SkuAttrSingleGroup {
  id: number,
  name: string,
  value: SkuAttrValue
}

export class Sku {
  id: number;
  skuAttrGroup: SkuAttrSingleGroup[];
  _price: SkuPrice;
  constructor(oneSkuAttrMap: SkuPriceAndId) {
    this.id = oneSkuAttrMap.id;
    this._price = new SkuPrice(oneSkuAttrMap.price, oneSkuAttrMap.promotionPrice);
    // this.skuAttrGroup = getSkuAttrFromSkuAttrIdIndex(this.id);
  }
}

